import React from 'react';
import { ConstantKeysWidgets } from '@photocarbone/nooco-shared-api-def';
import { FixedDisplay } from '@photocarbone/nooco-ui';
import { ModalNooco, Button } from '@photocarbone/nooco-ui';
import { useDispatch, useSelector } from 'react-redux';
import { StateDTO } from '../../../../models/GeneralDTO';
import { updateCheckValue } from '../../../../../actions/report';
import histogramPreview from '../../../../../assets/images/pdfbuilder/histogram-preview.png';
import tablePreview from '../../../../../assets/images/pdfbuilder/table-preview.png';
import acvPreview from '../../../../../assets/images/pdfbuilder/acv-preview.png';
import { useTranslation } from 'react-i18next';
import { Widget } from '..';

const WidgetPreview = () => {
  const { t } = useTranslation();
  const { widgetInPreview } = useSelector((state: StateDTO) => state.report);
  const dispatch = useDispatch();

  const renderFixedDisplay = (widgetPreview: Widget) => {
    return (
      <FixedDisplay
        text={widgetPreview.text}
        secondText={widgetPreview.secondText}
        img={widgetPreview.imgPath}
        imgPosition={widgetPreview.imgPosition}
      />
    );
  };
  const renderPreview = (widgetPreview: Widget) => {
    switch (widgetPreview?.key) {
      case ConstantKeysWidgets.HISTOGRAM:
        return (
          <>
            <img
              style={{ width: '800px', marginBottom: '10px' }}
              src={histogramPreview}
              alt="histogram"
            />

            <p>
              {t('APP.PDFBUILDER.WIDGETPREVIEW.HISTOGRAM', {
                defaultValue:
                  'Présentation des principaux contributeurs à l’impact sur le projet en fonction de l’unité du projet',
              })}
            </p>
          </>
        );
      case ConstantKeysWidgets.TEXTAREA:
        return <div>Saisissez du texte à insérer dans votre PDF</div>;
      case ConstantKeysWidgets.ACV:
        return (
          <>
            <img
              style={{ width: '800px', marginBottom: '10px' }}
              src={acvPreview}
              alt="acv"
            />
            <p>
              {t('APP.PDFBUILDER.WIDGETPREVIEW.ACV', {
                defaultValue:
                  'Analyse de cycle de vie du projet et de ses variantes éventuelles',
              })}
            </p>
          </>
        );
      case ConstantKeysWidgets.TEXT:
        return <div>{renderFixedDisplay(widgetPreview)}</div>;
      case ConstantKeysWidgets.TABLE:
        return (
          <>
            <img
              style={{ width: '800px', marginBottom: '10px' }}
              src={tablePreview}
              alt="table"
            />

            <p>
              {t('APP.PDFBUILDER.WIDGETPREVIEW.TABLE', {
                defaultValue:
                  'Tableau récapitulatif du projet : les différentes zones et leur surfaces, l’impact carbone de chacune de ces zones et le seuil associé s’il existe.',
              })}
            </p>
          </>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <ModalNooco
      cancelFunction={() => dispatch(updateCheckValue('widgetInPreview', null))}
      validateFunction={() => dispatch(updateCheckValue('widgetInPreview', null))}
      isOpen={widgetInPreview}
      needCustomFooter={() => (
        <div>
          <Button
            className="close-button"
            text={t('APP.FULLSCREENMODAL.CLOSE', { defaultValue: 'Fermer' })}
            onClick={() => dispatch(updateCheckValue('widgetInPreview', null))}
            style={{ marginRight: '10px' }}
          />
        </div>
      )}
      width={1000}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {renderPreview(widgetInPreview)}
      </div>
    </ModalNooco>
  );
};

export default WidgetPreview;
